/**
 * Demo mode toggle — persists in localStorage. When set, api() forwards
 * X-Waypoint-Account-Override on every call, switching the active account
 * to the shared Waypoint demo workspace.
 *
 * Access gating happens server-side (DEMO_ALLOWED_EMAILS env var). The
 * frontend just sends the header; if the caller isn't allowed, the worker
 * silently ignores it.
 */
const KEY = 'waypoint:demo-account-id';

export function getDemoAccountId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setDemoAccountId(id: string | null): void {
  if (typeof window === 'undefined') return;
  try {
    if (id) window.localStorage.setItem(KEY, id);
    else window.localStorage.removeItem(KEY);
  } catch {
    /* localStorage disabled — silently ignore */
  }
  // Broadcast so React Query / banners can react without a full reload.
  window.dispatchEvent(new CustomEvent('waypoint:demo-mode-changed'));
}

export function isDemoActive(): boolean {
  return !!getDemoAccountId();
}
